/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LightweightDealReward
 */
export interface LightweightDealReward {
    /**
     * 
     * @type {number}
     * @memberof LightweightDealReward
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof LightweightDealReward
     */
    readonly name: string;
    /**
     * 
     * @type {string}
     * @memberof LightweightDealReward
     */
    readonly image: string;
}

/**
 * Check if a given object implements the LightweightDealReward interface.
 */
export function instanceOfLightweightDealReward(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "image" in value;

    return isInstance;
}

export function LightweightDealRewardFromJSON(json: any): LightweightDealReward {
    return LightweightDealRewardFromJSONTyped(json, false);
}

export function LightweightDealRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): LightweightDealReward {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'image': json['image'],
    };
}

export function LightweightDealRewardToJSON(value?: LightweightDealReward | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

